import {
  shouldUseMockSharingEdit,
  shouldshouldUseMockSharingEditWithoutYield,
} from '../utils/mocks';
import { requestPost } from '../utils/request';

const BASE_URL = '/api/v5/fields/authorization/query';

/**
 * Get the field permissions for the current authenticated user
 * @param {String} fieldId
 * @return {Promise} Response
 */
export function requestFieldPermission(fieldId) {
  let mockFile = 'sharing/default';

  if (shouldUseMockSharingEdit()) {
    mockFile = 'sharing/edit';
  } else if (shouldshouldUseMockSharingEditWithoutYield()) {
    mockFile = 'sharing/editWithoutYield';
  }
  return requestPost(BASE_URL, {
    mockFile,
    data: {
      fieldIds: [fieldId],
    },
  });
}
